const HIDDEN_CLASS_SEARCH = 'overlay-search--hidden';
const getOverlayContainer = () => document.querySelector('#search-overlay');
const getSearchTriggers = () => document.querySelectorAll('.search-overlay-trigger');

const closeSearch = () => {
    const $overlayContainer = getOverlayContainer();
    $overlayContainer.classList.add(HIDDEN_CLASS_SEARCH);
    const event = new CustomEvent('search-overlay-close');
    document.dispatchEvent(event);
};

const getIsSearchHidden = () => {
    const $overlayContainer = getOverlayContainer();
    return $overlayContainer.classList.contains(HIDDEN_CLASS_SEARCH);
};

const openSearch = () => {
    const $overlayContainer = getOverlayContainer();
    $overlayContainer.classList.remove(HIDDEN_CLASS_SEARCH);
    const event = new CustomEvent('search-overlay-open');
    document.dispatchEvent(event);
};

const toggleSearch = () => {
    if (getIsSearchHidden()) {
        openSearch();
    } else {
        closeSearch();
    }
};

const initSearchOverlayEvents = () => {
    const $triggers = getSearchTriggers();

    for (const $trigger of $triggers) {
        $trigger.addEventListener('click', (event) => {
            event.preventDefault();

            toggleSearch();
        });
    }
};

const init = () => {
    initSearchOverlayEvents();
};

export { init };
